<template>
  <div class="pages" v-loading="listLoading">
    <div
        v-for="(item, index) in templateData.TemplateContent.Controls"
        :key="index"
    >
      <Digit v-if="item.Property.Control == 'Number'" :data-val="item"></Digit>
      <Contact
          v-if="item.Property.Control == 'Condition'"
          :data-val="item"
      ></Contact>
      <!--      @child-event="getDateVal"-->
      <Dates v-if="item.Property.Control == 'DateTime'"
             :data-val="item"></Dates>
      <Version
          v-if="item.Property.Control == 'Text'"
          @child-event="getTextVal"
          :data-val="item"
      ></Version>
      <Money v-if="item.Property.Control == 'Money'" :data-val="item"></Money>
      <Tips v-if="item.Property.Control == 'Tips'" :data-val="item"></Tips>
      <File v-if="item.Property.Control == 'File'" :data-val="item"></File>
      <Table
          v-if="item.Property.Control == 'Table'"
          @child-event="tableOperation"
          :data-val="item"
      ></Table>
      <Selector
          v-if="item.Property.Control == 'Selector'"
          @child-event="getSelectorVal"
          :data-val="item"
      ></Selector>
      <Textarea
          v-if="item.Property.Control == 'Textarea'"
          :data-val="item"
      ></Textarea>
      <Choose
          v-if="item.Property.Control == 'Contact'"
          @child-event="clickChoose"
          :data-val="item"
      ></Choose>
    </div>
    <Button
        class="submit-process"
        v-on:click="submit"
        v-bind:disabled="isDisabled"
        v-bind:loading="formLoading"
        size="large"
        type="primary"
    >
      提交
    </Button>
  </div>
</template>

<script>
/**
 * Version 为Text文本组件
 */
import Digit from "../components/Number.vue";
import Contact from "../components/Contact.vue";
import Version from "../components/Text.vue";
import Money from "../components/Money.vue";
import Tips from "../components/Tips.vue";
import File from "../components/File.vue";
import Dates from "../components/DateTime.vue";
import Table from "../components/Table.vue";
import Selector from "../components/Selector.vue";
import Textarea from "../components/Textarea.vue";
import Choose from "../components/Choose.vue";
import stringUtils from "../assets/js/stringUtil.js";
import {initWxConfig} from "../api/jssdk.js";
import {getTemplateInfo, submitProcessCopy} from "@/api/approval";
import {getRelation} from "@/api/employee";

import {
  getRemainingMeetingRoomName,
  conferenceRoomTakeFill
} from "@/api/ResourceBorrowing";

var isSubmit = false;

var template = {
  TemplateContent: {
    Controls: [],
  },
};
export default {
  components: {
    Contact,
    Version,
    Money,
    Tips,
    File,
    Table,
    Digit,
    Selector,
    Textarea,
    Choose,
    Dates,
  },
  data() {
    return {
      templateData: template,
      relationList: null,
      logInfo: null,
      templateId: "",
      spNo: null,
      formLoading: false,
      listLoading: false,
      isDisabled: false,
      listIsShow:false,
      equipmentName:null,
      borrowingList: [],
      borrowing: null,
      Options:null
    };
  },
  created() {
    this.logInfo = this.getLoginUserInfo();
    initWxConfig(this);
    this.templateId = this.$route.query.templateId;
    this.spNo = this.$route.query.spNo;
    this.getTemplate();
    stringUtils.setAddIsShow(false);
  },
  methods: {
    clickChoose: async function (dataVal, name) {
      var that = this;
      window.wx.invoke(
          "selectEnterpriseContact",
          {
            fromDepartmentId: 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
            mode: "single", // 必填，选择模式，single表示单选，multi表示多选
            type: ["department"], // 必填，选择限制类型，指定department、user中的一个或者多个
            selectedDepartmentIds: [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
            selectedUserIds: [], // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
          },
          async function (res) {
            if (res.err_msg === "selectEnterpriseContact:ok") {
              if (typeof res.result == "string") {
                res.result = JSON.parse(res.result); //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
              }
              // 已选的部门列表
              var depart = res.result.departmentList[0];
              dataVal.Values = [];
              dataVal.Values.push([depart.id, depart.name]);
              dataVal.Value = depart.name;
            }
          }
      );
    },
    tableOperation(val, type, datas) {
      this.tableoperation(val, type, datas, this);
    },
    getSelectorVal:async function(val, name) {
      const conls = this.templateData.TemplateContent.Controls;
      if (name === "会议室名称"){
        let value = this.Options.filter(e => e.Key === val)[0].Value[0].Text;
        let front = `${value.charAt(0)}${value.charAt(value.length - 1)}`
        if (value === "媒体室" || value === "培训室"){
          front = value
        }
        conls.forEach(item => {
          if(item.Property.Title[0].Text.indexOf("物品") > -1){
            if(item.Property.Title[0].Text === `${front}物品`){
              let options = item.Config.Selector.Options;
              let keys = this.Select(options,e => e.Key);
              item.ValuesSelect = []
              item.ValuesSelect = keys
              item.Values = []
              keys.forEach(key => item.Values.push([key]))
              item.IsShow = true;
            }else{
              item.ValuesSelect = []
              item.Values = null
              item.IsShow = false;
            }
          }
        })
      }
    },
    /**
     * 获取数组中的某一个数
     * */
    Select(arr,callback){
      let results = [];
      for (let i = 0; i < arr.length; i++) {
        let key = callback(arr[i])
        results.push(key)
      }
      return results
    },
    getTextVal() {},
    buildObject(){
      var ReceiverInformation = {
        /**
         * 会议室名称
         * */
        MeetingRoomName:'',

        /**
         * 物品名称
         * */
        ArticleName:[],

        /**
         * 拿取人名称
         * */
        Name:'',

        /**
         * 拿取工号
         * */
        EmpNo:'',

        /**
         * 拿取人部门
         * */
        DeptName:'',

        /**
         * 拿取时间
         * */
        Time:''
      }
      return this.filling(ReceiverInformation);
    },
    CheckFill(){
      let ValuesSelect = null;
      let SelectValue = [];
      let result = null
      this.templateData.TemplateContent.Controls.forEach(item => {
        if (item.Property.Title[0].Text === "会议室名称"){
          let options = item.Config.Selector.Options;
          options.forEach(option => {
            if (option.Key === item.Value){
              result = option.Value[0].Text
            }
          })
        }
        if (item.Property.Title[0].Text === "物品"){
          ValuesSelect = item.ValuesSelect
          let options = item.Config.Selector.Options;
          for (let i = 0; i < options.length; i++) {
            let option = options[i]
            if (ValuesSelect.indexOf(option.Key) > -1){
              SelectValue.push(option.Value[0].Text)
            }
          }
        }
      })
      return {
        SelectValue:SelectValue,
        Result:result
      };
    },
    /**
     * 填充数据
     * @param obj
     * @returns {*}
     */
    filling(obj){
      obj.Name = this.logInfo.EmpName
      obj.EmpNo = this.logInfo.EmpNo
      obj.DeptName = this.logInfo.DeptName

      /*
      * 填充多选框(多个物品)
      * */
      let {SelectValue,Result} = this.CheckFill();
      obj.ArticleName = SelectValue
      /**
       * 填充单选框
       * */
      obj.MeetingRoomName = Result
      var data = new Date();
      var month =data.getMonth() < 9 ? "0" + (data.getMonth() + 1) : data.getMonth() + 1;
      var date = data.getDate() <= 9 ? "0" + data.getDate() : data.getDate();
      var dateTime = `${data.getFullYear()}-${month}-${date} ${data.getHours()}:${data.getMinutes() > 9 ? data.getMinutes() : '0'+data.getMinutes()}:${data.getSeconds() > 9 ? data.getSeconds() : '0' + data.getSeconds()}`
      obj.Time = dateTime
      return obj
    },
    getArrDifference(arr1, arr2) {
      return arr1.concat(arr2).filter(function(v, i, arr) {
        return arr.indexOf(v) === arr.lastIndexOf(v);
      });
    },
    getUuid () {
      var s = [];
      var hexDigits = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
      for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
      }
      s[14] = "4"
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)
      s[8] = s[13] = s[18] = s[23] = "-"
      let uuid = s.join("")
      return uuid
    },
    getTemplate: async function () {
      var that = this;
      that.listLoading = true;
      const departName = that.logInfo.fullName;
      const jobLevel = that.logInfo.JobLevel;
      const empName = that.logInfo.EmpName;
      const positionName = that.logInfo.PositionName;
      await getTemplateInfo(this.templateId).then((response) => {
        var controls = response.Body;
        var that = this;
        let executiveDirector = [];
        for (let i = 0; i < controls.TemplateContent.Controls.length; i++) {
          let item = controls.TemplateContent.Controls[i];
          if (item.Property.Title[0].Text === "拿取者"){
            let children = item.Config.Table.Children;
            children.forEach(child => {
              if (child.Property.Title[0].Text === "姓名"){
                child.Value = that.logInfo.EmpName
                child.Disable = true
              }
              if (child.Property.Title[0].Text === "工号"){
                child.Value = that.logInfo.EmpNo
                child.Disable = true
              }
              if (child.Property.Title[0].Text === "部门"){
                child.Value = that.logInfo.DeptName
                child.Disable = true
              }
            })
          }
          if (item.Property.Title[0].Text === "会议室名称"){
            this.Options = item.Config.Selector.Options;
          }
          if (item.Property.Title[0].Text.indexOf("物品") > -1){
            item.IsShow = false
          }
          if (item.Property.Title[0].Text === "拿取时间"){
            item.IsShow = false
          }
        }
        this.templateData = this.assignControl(controls, that.logInfo);
        this.listLoading = false;
      });
      getRemainingMeetingRoomName().then(res => {
        let data = res.Body;
        if (data !== null && data.length > 0){
          this.templateData.TemplateContent.Controls.forEach(col => {
            if (col.Property.Title[0].Text === "会议室名称"){
              let options = col.Config.Selector.Options;
              data.forEach(item => {
                options = options.filter(f => f.Value[0].Text !== item)
              })
              this.$set(col.Config.Selector,"Options",options)
            }
          })
        }
      })
    },
    submit: async function () {
      this.isDisabled = true;
    //构建
      var conferenceRoom = this.buildObject();
      this.templateData.TemplateContent.Controls.forEach(item => {
        if(item.Property.Title[0].Text === "拿取时间"){
          item.Value = conferenceRoom.Time
        }
      })
      //数据校验
      if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
        return;
      }


      //审批人所见

      /*this.templateData.TemplateContent.Controls.forEach(item => {
        if (item.Property.Title[0].Text === "表单信息"){
          let children = item.Config.Table.Children;
          children.forEach(child => {
            if (child.Property.Title[0].Text === "会议室名称"){
              child.Value = conferenceRoom.MeetingRoomName;
            }
            if (child.Property.Title[0].Text === "物品名称"){
              let val = "";
              conferenceRoom.ArticleName.forEach((name,index) => {
                if (index === conferenceRoom.ArticleName.length - 1){
                  val += `${name}`
                }else{
                  val += `${name},`
                }
              })
              child.Value = val;
            }
            if (child.Property.Title[0].Text === "拿取时间"){
              child.Value = conferenceRoom.Time;
            }
          })
        }
      })*/

      var SummaryList = [];

      var info = { SummaryInfo: [] };
      info.SummaryInfo = [];
      info.SummaryInfo.push({
        Text: `拿取者： ${this.logInfo.EmpName}  ${this.logInfo.EmpNo}  ${this.logInfo.DeptName}`,
        Lang: "zh_CN",
      });
      SummaryList.push(info);

      var info = { SummaryInfo: [] };
      info.SummaryInfo = [];
      info.SummaryInfo.push({
        Text: "会议室名称：" + " " + conferenceRoom.MeetingRoomName,
        Lang: "zh_CN",
      });
      SummaryList.push(info);

      var info = { SummaryInfo: [] };
      info.SummaryInfo = [];
      info.SummaryInfo.push({
        Text: `拿取时间: ${conferenceRoom.Time}`,
        Lang: "zh_CN",
      });
      SummaryList.push(info);
      this.templateData.SummaryList = SummaryList;

      //提交
      submitProcessCopy(
          this.templateId,
          this.logInfo.EmpNo,
          this.spNo,
          {
            "dto":this.templateData,
          }
      )
          .then((response) => {
            this.templateData.TemplateContent.Controls.forEach(item => {
              if(item.Property.Title[0].Text === "拿取时间"){
                item.Value = conferenceRoom.Time
                item.IsShow = false
              }
            })
            if (response.Body.ErrCode !== 0) {
              this.Message({
                message: "申请失败，请稍后重试",
                type: "error",
                duration: 3 * 1000,
              });
            }else{
              //保存数据
              //conferenceRoomTakeFill(conferenceRoom)
              this.Message({
                message: "申请成功",
                type: "success",
                duration: 1000,
              });
              setTimeout(() => {
                this.$router.push("/index");
              }, 1000);
            }
          })
          .catch((err) => {
            this.templateData.TemplateContent.Controls.forEach(item => {
              if(item.Property.Title[0].Text === "拿取时间"){
                item.Value = conferenceRoom.Time
                item.IsShow = false
              }
            })
            this.isDisabled = false;
          })
          .finally(() => {
            isSubmit = false;
            this.listLoading = false;
          });
    },
  },
};
</script>

<style lang="less" scoped>
.pricing-list {
  padding: 10px;
  margin-top: 0px;
  .totle {
    font-size: 12px;
    margin-top: 10px;
    span {
      color: #ff4346;
      padding: 0 4px;
    }
  }
  .pricing-item {
    width: 100%;
    background: #ffffff;
    position: relative;
    padding: 8px;
    margin-top: 10px;
    border-radius: 6px;
    box-shadow: 6px 6px 6px #cccccc;
    .title {
      font-size: 13px;
      color: #585354;
      line-height: 1.8;
      width: calc(100% - 40px);
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      padding-bottom: 4px;
    }
    .applicant-time {
      color: #585354;
      font-size: 12px;
      line-height: 1.7;
      div.applicant {
        width: 80%;
        float: left;
      }
      div.time {
        width: 40%;
        float: right;
        text-align: right;
      }
    }
    .label {
      position: absolute;
      right: 5px;
      top: 10px;
    }
    .waiting-pricing {
      color: #3fc243;
    }
    .waiting-check {
      color: #55acee;
    }
  }
  .pricing-list-current{
    border: 2px solid #b9d5ec;
    box-shadow: 6px 6px 6px #78b4e6;
  }
  .pricing-item:first-child {
    margin-top: 0;
  }
}
</style>